<template>
  <section class="mb-6">
    <v-card
      data-testid="sectionScoringGroup-card-sectionHeader"
      outlined
      class="section-header-card section-header-card--primary px-6 py-5 d-flex align-center justify-space-between mb-4"
      :style="sectionHeaderStyle"
      @click.native="emitSectionActivation"
      @focusin.native="emitSectionActivation"
    >
      <span class="body-1 font-weight-600 blue-grey--text text--darken-3">
        {{ `${section.title || fallbackTitle}` }}
      </span>

      <section
        class="section-scoring-group__weight-column d-flex flex-column align-end"
      >
        <v-text-field
          v-disable-number-scroll
          class="section-scoring-group__weight-input"
          dense
          hide-details
          max="100"
          min="0"
          ref="weightInput"
          suffix="%"
          type="number"
          :label="$t('routines.scoring.weight_label')"
          :rules="sectionWeightRules"
          :value="section.weightPercentage"
          @input="handleWeightChange"
        />
      </section>
    </v-card>

    <QuestionScoringCard
      v-for="(question, questionIndex) in section.items"
      :key="
        question.scoringItemId || question._id || question.id || questionIndex
      "
      :active="activeQuestionId === question.scoringItemId"
      :item="question"
      :index="questionIndex"
      :isInsideSection="true"
      :borderColor="borderColor"
      @activateQuestion="handleQuestionActivation"
      @change="handleQuestionChange"
    />
  </section>
</template>

<script>
import QuestionScoringCard from './QuestionScoringCard.vue'
import {
  getScoringItemId,
  normalizeSectionWeightInput
} from './scoring/scoringShared'
import { createSectionWeightRules } from './scoring/scoringValidation'

export default {
  name: 'SectionScoringGroup',

  components: {
    QuestionScoringCard,
  },

  props: {
    section: {
      type: Object,
      required: true,
    },
    activeQuestionId: {
      type: String,
      default: null,
    },
    activeSection: {
      type: Boolean,
      default: false,
    },
    sectionIndex: {
      type: Number,
      required: true,
    },
    fallbackTitle: {
      type: String,
      required: true,
    },
    borderColor: {
      type: String,
      default: null,
    },
  },

  computed: {
    sectionWeightRules() {
      return createSectionWeightRules({
        translate: key => this.$t(`routines.scoring.${key}`),
      })
    },

    sectionWeightErrorMessage() {
      const failedRule = this.sectionWeightRules.find(
        rule => rule(this.section.weightPercentage) !== true
      )

      return failedRule ? failedRule(this.section.weightPercentage) : ''
    },

    sectionHeaderStyle() {
      if (this.activeSection) {
        return 'border-color: #167DEC !important; border-width: 2px !important;'
      }

      if (!this.borderColor) {
        return ''
      }

      return `border-left-width: 4px !important; border-left-color: ${this.borderColor} !important;`
    },
  },

  methods: {
    emitSectionActivation() {
      this.$emit('activateSection', this.section.itemId)
    },

    handleWeightChange(value) {
      const sectionItemId = getScoringItemId(
        { scoringItemId: this.section.itemId },
        this.sectionIndex
      )

      this.$emit('weightChange', {
        sectionItemId,
        weightPercentage: normalizeSectionWeightInput(value),
      })
    },

    handleQuestionChange(payload) {
      this.$emit('questionChange', payload)
    },

    handleQuestionActivation(itemId) {
      this.$emit('activateQuestion', itemId)
    },
  },
}
</script>

<style scoped lang="scss">
.section-header-card {
  border-color: $color-blue-grey-lighten2 !important;
  background-color: $color-white;
  border-left-width: 4px;
}

.section-scoring-group__weight-column {
  min-width: 240px;
}

.section-scoring-group__weight-input {
  width: 120px;
}

.section-scoring-group__weight-error {
  max-width: 240px;
  text-align: right;
}

.section-scoring-group__weight-input::v-deep .v-input__slot {
  margin-bottom: 0;
}
</style>
